import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import algoliasearch from 'algoliasearch/lite';
import { environment } from 'src/environments/environment';
import { Language } from '../../models/language.model';
import { User } from '../../models/user.model';
import { AuthService } from '../../services/auth.service';
import { AppEvents, EventBusService } from '../../services/event-bus.service';
import { UserService } from '../../services/user.service';
import { FormLoginComponent } from './components/formLogin/formLogin.component';
const searchClient = algoliasearch(
  environment.algolia.appId,
  environment.algolia.apiKey
);
@Component({
  selector: 'dashboard-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent implements OnInit {
  public client: string;
  public homeUrl: string;
  public isOfferPage: boolean;
  appLanguages: Language[] = [];
  currentLang: Language = environment.defaultLanguage;
  configOffer = {
    indexName: '',
    searchClient: searchClient
  };
  configService = {
    indexName: '',
    searchClient: searchClient
  };

  currentUser: User;
  isUserLogin = false;

  showSearchBar: boolean;

  @ViewChild('formLogin') formLogin: FormLoginComponent;
  constructor(
    private bus: EventBusService,
    public dialog: MatDialog,
    private _userService: UserService,
    private authService: AuthService,
    private router: Router,
    public translate: TranslateService
  ) {
    this.client = `${localStorage.getItem('client')}`;
    if (!localStorage.getItem('selectedLanguage')) {
      localStorage.setItem(
        'selectedLanguage',
        JSON.stringify(environment.defaultLanguage)
      );
    }
    this.bus.on(AppEvents.router).subscribe((route) => {
      this.showSearchBar = !route.includes('worker-home');
      this.setAlgoliaConf(route);
    });
    this.appLanguages = environment.appLanguages.filter(
      (a) => a.isDefault === true
    );
    this.currentLang =
      JSON.parse(localStorage.getItem('selectedLanguage')) ||
      environment.defaultLanguage;
  }

  ngOnInit(): void {
    this.client = `${localStorage.getItem('client')}`;
    this.bus.on(AppEvents.update.profile).subscribe(this.updateUser);
    this.isUserLogin = this.authService.isLoggedIn();
    if (this.isUserLogin === true) this.getCurrentUserData();
  }

  setAlgoliaConf(router) {
    if (router.includes('services')) {
      this.configService = {
        indexName: 'service',
        searchClient: searchClient
      };
      this.isOfferPage = false;
    } else {
      this.configOffer = {
        indexName: 'offer',
        searchClient: searchClient
      };
      this.isOfferPage = true;
    }
  }
  updateUser = (profile: any) => {
    this.isUserLogin = true;
    this.currentUser ??= {} as User;
    this.currentUser.image = profile.image;
    this.currentUser.isWorker = profile.isWorker;
    this.currentUser.isCustomer = profile.isCustomer;
    this.currentUser.name = profile.name;
  };

  getCurrentUserData() {
    this._userService.getUserData().subscribe((response: any) => {
      this.currentUser = response;
      this.updateUser(this.currentUser);
    });
  }

  signOut() {
    this.authService.logout().subscribe((success) => {
      if (success) {
        localStorage.removeItem('userIdRole');
        this.isUserLogin = false;
        this.currentUser = null;
        this.router.navigateByUrl('/webcliente/home');
      }
    });
  }
  menuClosed() {
    this.formLogin?.loginFormShared?.loadForm();
  }
  updateLanguage(language: any) {
    if (language.key !== this.currentLang.key) {
      this.currentLang = language;
      this.translate.use(language.key).subscribe(() => {
        this.bus.emit(AppEvents.update.language, language);
      });
      localStorage.setItem('selectedLanguage', JSON.stringify(language));
      window.location.reload();
    }
  }
}
